import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C7.05667 21.9348 3.06515 17.9433 2.99999 13C3.06515 8.05666 7.05667 4.06514 12 3.99999C16.9433 4.06514 20.9348 8.05666 21 13C20.9348 17.9433 16.9433 21.9348 12 22ZM12 5.99999C8.15516 6.0506 5.05061 9.15515 4.99999 13C5.05061 16.8448 8.15516 19.9494 12 20C15.8448 19.9494 18.9494 16.8448 19 13C18.9494 9.15515 15.8448 6.0506 12 5.99999ZM13 18H11V14H6.99999V12H11V7.99999H13V12H17V14H13V18ZM20.292 6.70799L17.283 3.70799L18.692 2.29099L21.702 5.29099L20.292 6.70699V6.70799ZM3.70899 6.70799L2.29199 5.29099L5.28299 2.29099L6.69799 3.70699L3.70899 6.70699V6.70799Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "AlarmAdd"
);
